import React from 'react'
import { Typography, Card, Box } from '@mui/material'
import { getCardTypeIcon } from 'utils/cards'
import { useTranslation } from 'react-i18next'

type PaymentMethod = {
  paymentProfileId: string
  billingAddress: {
    firstName: string
    lastName: string
  }
  cardNumber: string
  cardType?: string
}

type PaymentMethodsProps = {
  paymentMethods: PaymentMethod[]
  selectedPaymentMethodId: string | null
  handlePaymentMethodClick: (paymentProfileId: string) => void
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({
  paymentMethods,
  selectedPaymentMethodId,
  handlePaymentMethodClick
}) => {
  const { t } = useTranslation()

  return (
    <Box>
      {paymentMethods.length > 0 ? (
        paymentMethods.map(method => (
          <Card
            key={method.paymentProfileId}
            variant='outlined'
            sx={{
              p: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderWidth: 2,
              borderColor:
                selectedPaymentMethodId === method.paymentProfileId
                  ? 'primary.main'
                  : '#E0E0E0',
              cursor: 'pointer',
              '&:hover': {
                borderColor: 'primary.main'
              },
              my: 2
            }}
            onClick={() => handlePaymentMethodClick(method.paymentProfileId)}
          >
            <Typography variant='body1'>
              {method.billingAddress.firstName} {method.billingAddress.lastName}
              <br />
              {method.cardNumber}
            </Typography>

            <Box
              component='img'
              src={getCardTypeIcon(method.cardType ?? 'default')}
              alt={method.cardType}
              sx={{
                marginRight: '8px',
                height: '50px'
              }}
            />
          </Card>
        ))
      ) : (
        <Typography variant='body1'>
          {t('checkout.noPaymentMethods')}
        </Typography>
      )}
    </Box>
  )
}

export default PaymentMethods
